import qs from "query-string";
import SparkMD5 from "spark-md5";
import moment from "moment";
import { FILE_DOWNLOAD_GET } from "src/fetch/url";
import { commonImage, pathPrefix } from "./commonData";
import ExcelJS from "exceljs";

/**
 *
 * 判断产品是否失效
 * @param {object} product
 * @param {string} product.state 产品状态
 * @returns {boolean}
 */
export function isProductValid(product) {
  if (!product) {
    return false;
  }
  return product.state === "ACTIVE";
}

export const productState = {
  ACTIVE: "ACTIVE",
  INACTIVE: "INACTIVE",
  DELETE: "DELETE",
};

/**
 *
 * 当表格可编辑时，重定义columns
 * @param {array} originColumn 原始列定义
 * @returns {array} 合并后的列定义数组
 */
export function mergeColumns(originColumn, otherProps) {
  return originColumn.map((col) => {
    // if (!col.editable) {
    //   return col;
    // }
    return {
      ...col,

      onCell: (record, idx) => ({
        idx,
        dataIndex: col.dataIndex,
        editable: col.editable,
        record,
        ...col,
        ...otherProps,
      }),
    };
  });
}
/**
 *
 * 解析url参数
 * @param {string} conditions
 * @returns {object}
 */
export const getUrlParams = (conditions) => {
  let conditionsStr = conditions.substr(1);
  const condList = conditionsStr.split("&");
  const params = {};
  for (let i = 0; i < condList.length; i++) {
    const items = condList[i].split("=");
    if (items[0] === "data") {
      params[items[0]] = JSON.parse(items[1]);
    } else {
      params[items[0]] = items[1];
    }
  }
  return params;
};

/**
 *
 * 格式价格金额
 * @param {number} money
 * @param {string} symbol 分隔符
 * @param {string} currency 货币符号
 * @returns {string}
 */
export const priceFormatter = (money, symbol = ",", currency = "¥") => {
  var amount = parseFloat((money + "").replace(/[^\d.-]/g, "")).toFixed(2) + "";
  if (isNaN(amount)) {
    return "";
  }

  var l = amount.split(".")[0].split("").reverse();
  var r = amount.split(".")[1];
  var t = "";
  for (let i = 0; i < l.length; i++) {
    t += l[i];
    if ((i + 1) % 3 === 0 && i + 1 !== l.length) {
      t += symbol;
    }
  }
  return currency + " " + t.split("").reverse().join("") + "." + r;
};
// 还原 已格式化金额为数值

export function priceParser(value) {
  if (typeof value !== "number" || isNaN(value)) {
    return 0;
  }
  const currency = "¥";
  const symbol = ",";
  const pureMoney = value.replace(currency, "");
  const moneyStr = pureMoney.trim().replace(symbol, "");

  if (isNaN(parseFloat(moneyStr))) {
    return 0;
  }
  return parseFloat(moneyStr);
}
// 用户枚举
// export const USER_CATEGORY = {
//   SALE:'SALE',
//   AGENT:'AGENT',
//   ADMIN: 'ADMIN',
// };

// 判断报价单状态
export function quotationIsAddMode(mode) {
  return mode === "add";
}
export function quotationIsModMode(mode) {
  return mode === "mod";
}
export function quotationIsCopyMode(mode) {
  return mode === "copy";
}
export function quotationIsViewMode(mode) {
  return mode === "view";
}
export function quotationIsFormal(state) {
  return state === "FORMAL";
}
export function quotationIsDraft(state) {
  return state === "DRAFT";
}
export function quotationIsTrash(state) {
  return state === "RECOVERY";
}
export function quotationIsReject(state) {
  return state === "REJECT";
}
/**
 *
 * 阿拉伯数字转汉字大写
 * @param {number} n 数字，最多2位小数
 * @returns {string} 大写的字符串
 */
export function moneyToChinese(n) {
  if (!/^(0|[1-9]\d*)(\.\d+)?$/.test(n)) {
    return "数据非法"; //判断数据是否大于0
  }

  var unit = "千百拾亿千百拾万千百拾元角分",
    str = "";
  n += "00";

  var indexpoint = n.indexOf("."); // 如果是小数，截取小数点前面的位数

  if (indexpoint >= 0) {
    n = n.substring(0, indexpoint) + n.substr(indexpoint + 1, 2); // 若为小数，截取需要使用的unit单位
  }

  unit = unit.substr(unit.length - n.length); // 若为整数，截取需要使用的unit单位
  for (var i = 0; i < n.length; i++) {
    str += "零壹贰叁肆伍陆柒捌玖".charAt(n.charAt(i)) + unit.charAt(i); //遍历转化为大写的数字
  }

  return str
    .replace(/零(千|百|拾|角)/g, "零")
    .replace(/(零)+/g, "零")
    .replace(/零(万|亿|元)/g, "$1")
    .replace(/(亿)万|壹(拾)/g, "$1$2")
    .replace(/^元零?|零分/g, "")
    .replace(/元$/g, "元整"); // 替换掉数字里面的零字符，得到结果
}

export function userIsAgent(user) {
  return user.category === "AGENT" || user.category === "AGENT_CHILD";
}
export function userIsParentAgent(user) {
  return user.category === "AGENT";
}
export function userIsSubAgent(user) {
  return user.category === "AGENT_CHILD";
}
// 用户角色是否为渠道经理
export function userIsSale(user) {
  return user.category === "SALE" && user.job === "CHANNEL_MANAGER";
}
export function userIsAdmin(user) {
  return user.category === "ADMIN";
}
export function userIsDirector(user) {
  return user.job === "DIRECTOR";
}
export function userIsProductAdmin(user) {
  return (
    user.category === "ADMIN" && user.roleName.indexOf("产品维护管理员") !== -1
  );
}
export function userIsSolutionAdmin(user) {
  return (
    user.category === "ADMIN" && user.roleName.indexOf("方案管理员") !== -1
  );
}
export function userIsSuperAdmin(user) {
  const roleList = user.roleName.split(",");
  return (
    user.category === "ADMIN" &&
    user.roleName.indexOf("超级管理员") !== -1 &&
    roleList.length === 1
  );
}
export function userIsFormal(user) {
  return user.state === "FORMAL";
}

export function userIsManager(user) {
  return user.job === "PRODUCT_MANAGER";
}

export function userIsAccountManager(user) {
  return user.job === "ACCOUNT_MANAGER" || user.job === "BUSINESS_OWNER";
}

// const unAuthState = ['REGISTER','AUDITFAIL','FREEZE','DELETE','AUDITING'];
const authState = "FORMAL";
const whiteList = [
  "/main/usercenter/usercenter/account",
  "/main/usercenter/usercenter/user",
  "/main/usercenter/usercenter/company",
  "/main/usercenter/usercenter/QAshow",
];
const whiteUrlList = ["/loading", "/main/loading", "/login"];
export const imgFormat = ["image/png", "image/jpg", "image/jpeg", "image/svg"];

export const userState = {
  REGISTER: "REGISTER",
  AUDITING: "AUDITING",
  AUDITFAIL: "AUDITFAIL",
  FREEZE: "FREEZE",
  DELETE: "DELETE",
};

export const checkPrivilege = (key, privileges = [], state) => {
  let path = key;
  if (key.indexOf("?") >= 0) {
    path = key.split("?")[0];
  }
  const pathLevel = path.split("/").length;
  for (let index = 0; index < whiteUrlList.length; index++) {
    if (pathPrefix + whiteUrlList[index] === path) {
      return true;
    }
  }
  for (let i = 0; i < privileges.length; i++) {
    const privilegeKey = pathPrefix + privileges[i].key;
    const keyLevel = privilegeKey.split("/").length;
    const urlMatch =
      keyLevel === pathLevel
        ? privilegeKey === path
        : privilegeKey.indexOf(path) >= 0;
    if (urlMatch && state === authState) {
      return true;
    } else if (urlMatch && state !== authState) {
      for (let j = 0; j < whiteList.length; j++) {
        if ((pathPrefix + whiteList[j]).indexOf(path) >= 0) {
          return true;
        }
      }
    }
  }
  return false;
  // return true;
};

//文件下载
export function download(url, filename) {
  if (!url) {
    return;
  }

  let link = document.createElement("a");
  link.style.display = "none";
  link.href = url;

  // link.setAttribute('download', data.fileName)  // 获取并设置下载文件名
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}

const iframeTag = "iframe-download-form-container";
function createIframe() {
  let iframe = document.getElementById(iframeTag);
  if (!iframe) {
    iframe = document.createElement("iframe");
    iframe.id = iframeTag;
    iframe.name = iframeTag;
    iframe.style.display = "none";
    document.body.appendChild(iframe);
  }
}

export function postDownload(url, params = {}) {
  if (Array.isArray(params) || typeof params !== "object") return false;
  var form = document.createElement("form");
  createIframe();
  form.action = url;
  form.method = "post";
  form.style.display = "none";
  form.target = iframeTag;
  document.body.appendChild(form);
  Object.keys(params).forEach((key) => {
    const input = document.createElement("input");
    input.type = "hidden";
    input.name = key;
    input.value = params[key] || "";
    form.appendChild(input);
  });
  form.submit();
  document.body.removeChild(form);

  setTimeout(() => {
    window.myInitFile?.();
  }, 1000);
}

export function getDownload(url, params = {}) {
  if (Array.isArray(params) || typeof params !== "object") return false;
  createIframe();
  params = qs.stringify(params);
  if (!/\?/.test(url)) {
    url = url + "?";
    url = `${url}${params}`;
  } else {
    url = `${url}&${params}`;
  }
  var elink = document.createElement("a");
  elink.download = "#";
  elink.style.display = "none";
  elink.href = url;
  elink.target = iframeTag;
  document.body.appendChild(elink);
  elink.click();
  document.body.removeChild(elink);

  setTimeout(() => {
    window.myInitFile?.();
  }, 1000);
}

export function getTimeState() {
  // 获取当前时间
  let timeNow = new Date();
  // 获取当前小时
  let hours = timeNow.getHours();
  // 设置默认文字
  let text = ``;
  // 判断当前时间段
  if (hours >= 0 && hours <= 10) {
    text = `早上好`;
  } else if (hours > 10 && hours <= 14) {
    text = `中午好`;
  } else if (hours > 14 && hours <= 18) {
    text = `下午好`;
  } else if (hours > 18 && hours <= 24) {
    text = `晚上好`;
  }
  return text;
}

/**
 * 生成 新建、复制 的配置组的名称
 * @param {array} group 配置组信息
 * @param {string} type 当前动作的类型，分别为 ADD <--> 添加; COPY <--> 复制
 * @param {string} originName 当状态为复制时，传入复制的原始配置组
 *
 * @returns {string} 配置组名称
 */
export function createGroupName(group, type, originName) {
  let defaultIndex = 0;
  let defaultName = type === "ADD" ? "新建配置组" : `${originName}复制`;
  let name = "";
  // const currNameList = group.map(g => g.title);
  if (checkGroupName(group, defaultName)) {
    name = defaultName;
  } else {
    while (true) {
      defaultIndex++;
      if (checkGroupName(group, defaultName + defaultIndex)) {
        name = defaultName + defaultIndex;
        break;
      }
    }
  }
  return name;
}

/**
 * 检查配置组名称是否已存在
 * @param {array} group 配置组信息
 * @param {string} name 配置组名称
 *
 * @returns {boolean} 名称唯一返回true，否则返回false
 */
export function checkGroupName(group, name) {
  const currNameList = group.map((g) => g.title);
  const hasName = currNameList.indexOf(name);
  return hasName < 0;
}

/**
 * 对象数组升序排序
 *
 * @param {array} arr | 需要排序的数组
 * @param {string} sortKey | 需要排序的字段
 */
export function ascSort(arr = [], sortKey) {
  arr.sort((a, b) => {
    return a[sortKey] - b[sortKey];
  });

  return arr;
}

// 判断是否为手机端
export const isMobile = () =>
  /(iPhone|iPad|iPod|iOS|Android)/i.test(navigator.userAgent);

/**
 * 文件列表数据格式化
 * @param {array} list | 文件列表
 * @returns
 */
export const formatterFileList = (list = []) => {
  const newList = [];
  list.forEach((item, index) => {
    // item.uid = `${new Date().getTime()}-${index}`;
    item.uid = item.uid ? item.uid : item.fileId || item.pictureId;
    item.name = item.fileName || item.pictureName;
    item.status = "done";
    item.url = `${FILE_DOWNLOAD_GET}?fileId=${item.fileId}`;
    newList.push(item);
  });

  return newList;
};

/**
 * 判断文件类型是否为图片
 * @param {string} type | 文件类型
 * @returns
 */
export const isImageFileType = (type) => type && type.indexOf("image/") === 0;

/**
 * 根据文件后缀名判断是否为pdf文件
 * @param {string} fileName | 文件名
 * @returns boolean
 */
export const isPDFType = (fileName = "") => {
  const fileNameSplit = fileName.split(".");
  let isPDF = false;
  fileNameSplit.forEach((_f) => {
    if (_f.toLowerCase() === "pdf") {
      isPDF = true;
      return;
    }
  });
  return isPDF;
};

/**
 * 检查上传文件后缀名是否合法
 * @param {string} type 文件类型
 * @returns boolean
 */
export const fileCheck = (name = "", correctFileExt) => {
  const typeList = name.split(".");
  const ext = typeList[typeList.length - 1];
  const isCorrect = correctFileExt.indexOf(ext) >= 0;
  return { isCorrect, ext };
};

/**
 * 获取文件后缀名
 * @param {string} name | 文件名称
 * @returns string
 */
export const getFileExt = (name = "") => {
  const typeList = name ? name.split(".") : [];
  const ext = typeList[typeList.length - 1];
  return ext;
};

/**
 * 根据文件后缀名判断是否是常见图片
 * @param {string} name | 文件名称
 * @returns boolean
 */
export const isCommonImage = (name) => {
  const ext = getFileExt(name);
  const isImage = commonImage.includes(ext.toLowerCase());
  return isImage;
};

/**
 * 判断文字是否有被折叠
 * @param {string} text 显示文字
 * @returns 被折叠true否则返回false
 */
export const isEllipsis = (text, width) => {
  const test = document.querySelector("#root");
  const checkDom = document.createElement("span");
  checkDom.innerText = text;
  test && test.append(checkDom);
  const flag = width < checkDom.offsetWidth;
  test && test.removeChild(checkDom);
  return flag;
};

/**
 * 根据cookie判断是否已经登录
 * @returns boolean 已登录 true 未登录 false
 */
export const isAuth = () => {
  const keys = document.cookie.match(/[^ =;]+(?==)/g) || [];
  return !!keys.includes("token");
};

/**
 * 清除所有cookies
 */
export function clearAllCookie() {
  var keys = document.cookie.match(/[^ =;]+(?==)/g);
  if (keys) {
    for (var i = keys.length; i--; )
      document.cookie = keys[i] + "=0;expires=" + new Date(0).toUTCString();
  }
}

/**
 * 获取文件MD5值
 * @param {Object} file 上传文件
 * @returns Promise
 */
export const getFileMd5 = (file) => {
  return new Promise((resolve) => {
    let currentChunk = 0;
    const blobSlice =
        File.prototype.slice ||
        File.prototype.mozSlice ||
        File.prototype.webkitSlice,
      // file = this.files[0],
      chunkSize = 8097152, // Read in chunks of 2MB
      chunks = Math.ceil(file.size / chunkSize),
      spark = new SparkMD5.ArrayBuffer(),
      fileReader = new FileReader();

    fileReader.onload = function (e) {
      spark.append(e.target.result); // Append array buffer
      currentChunk++;

      if (currentChunk < chunks) {
        loadNext();
      } else {
        const md5 = spark.end();
        resolve(md5);
      }
    };

    fileReader.onerror = function () {
      console.warn("oops, something went wrong.");
    };

    function loadNext() {
      var start = currentChunk * chunkSize,
        end = start + chunkSize >= file.size ? file.size : start + chunkSize;
      fileReader.readAsArrayBuffer(blobSlice.call(file, start, end));
    }

    loadNext();
  });
};

/**
 * 判断字符串是否为JSON字符串
 * @param {string} str 字符串
 * @returns bool 是否为JSON字符串
 */
export const isJSON = (str) => {
  if (typeof str === "string") {
    try {
      const obj = JSON.parse(str);
      if (typeof obj === "object" && obj) {
        return true;
      }
      return false;
    } catch (e) {
      return false;
    }
  }
  return false;
};

/**
 * 文件下载进度获取
 * @param {*} onProgress 进度回调方法
 * @param {*} file 上传文件
 * @returns func
 */
export const onUploadProgress = (onProgress, file) => (percent) => {
  onProgress({ percent: Math.round(percent * 100) }, file);
};

export const timeFormat = (text, record, index, format) => {
  return text ? moment(text).format(format || "YYYY-MM-DD") : "-";
};

export const enumToArray = (enumObj, fieldsName) => {
  const formatArr = [];
  if (!Array.isArray(enumObj) && typeof enumObj === "object") {
    Object.keys(enumObj).forEach((key) => {
      const item = enumObj[key];
      if (typeof item === "object") {
        const value = !fieldsName?.value
          ? item?.value
          : item?.[fieldsName.value];
        const label =
          !fieldsName?.label || fieldsName.label === "text"
            ? item.text
            : item[fieldsName.label];
        formatArr.push({
          value,
          label,
        });
        return;
      }
      formatArr.push({
        value: item,
        label: key,
      });
    });
  }
  return formatArr;
};

/** 判断是不是数智终端环境 */
export const isShuZhi = () => process.env.REACT_APP_ENV === "shuzhi";

export const fileNormalize = (e) => {
  if (Array.isArray(e)) {
    return e;
  }
  return e?.fileList;
};

/**
 * 计算剩余时间
 * @param {number|string} endTime 结束时间的时间戳或日期字符串
 * @returns {string} 剩余时间的文字描述
 */
export function getRemainingTime(endTime) {
  const end =
    typeof endTime === "string" ? new Date(endTime).getTime() : endTime;
  const now = new Date().getTime();
  const remaining = end - now;

  if (remaining <= 0) {
    return "已过期";
  }

  const days = Math.floor(remaining / (1000 * 60 * 60 * 24));
  const hours = Math.floor(
    (remaining % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
  );
  const minutes = Math.floor((remaining % (1000 * 60 * 60)) / (1000 * 60));

  if (days > 0) {
    return `剩余${days}天`;
  } else if (hours > 0) {
    return `剩余${hours}小时${minutes}分钟`;
  } else {
    return `剩余${minutes}分钟`;
  }
}

/**
 * 通用表格数据导出为Excel功能
 * @param {Array} data - 要导出的数据
 * @param {Array} columns - 列配置，格式为 [{title: '列标题', dataIndex: '数据字段', render: (可选)渲染函数}]
 * @param {string} fileName - 导出文件名，不包含扩展名
 */
export async function exportTableData(data, columns, fileName = "export") {
  // 创建工作簿和工作表
  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet("Sheet1");

  // 设置列标题
  worksheet.columns = columns.map((col) => ({
    header: col.title,
    key: col.dataIndex,
    width: 15, // 默认列宽
  }));

  // 添加数据行
  data.forEach((record) => {
    const rowData = {};
    columns.forEach((col) => {
      if (col.render) {
        // 如果有自定义渲染函数，使用渲染函数处理数据
        const renderedValue = col.render(record[col.dataIndex], record);

        // 处理 React 元素
        if (
          renderedValue &&
          typeof renderedValue === "object" &&
          renderedValue.props
        ) {
          // 获取 React 元素的文本内容
          const children = renderedValue.props.children;

          // 处理金额显示
          if (Array.isArray(children)) {
            // 如果是数组（比如 ["+", 14.68]），则根据第一个元素判断是否为负数
            const [sign, amount] = children;
            rowData[col.dataIndex] = sign === "-" ? `-${amount}` : amount;
          } else if (typeof children === "number") {
            // 如果是数字（比如负数 -12），直接使用
            rowData[col.dataIndex] = children;
          } else {
            // 如果是其他内容，检查是否为 "-"
            rowData[col.dataIndex] = children === "-" ? "" : children;
          }
        } else {
          // 如果渲染结果是 "-"，则替换为空字符串
          rowData[col.dataIndex] = renderedValue === "-" ? "" : renderedValue;
        }
      } else {
        // 对于时间字段特殊处理
        if (
          col.dataIndex === "ctime" ||
          col.dataIndex === "validityStartTime" ||
          col.dataIndex === "validityEndTime"
        ) {
          rowData[col.dataIndex] = record[col.dataIndex]
            ? moment(record[col.dataIndex]).format("YYYY-MM-DD")
            : "";
        } else {
          rowData[col.dataIndex] = record[col.dataIndex];
        }
      }
    });
    worksheet.addRow(rowData);
  });

  // 设置标题行样式
  const headerRow = worksheet.getRow(1);
  headerRow.font = { bold: true };
  headerRow.alignment = { vertical: "middle", horizontal: "center" };
  headerRow.height = 25; // 设置标题行高

  // 设置所有数据单元格的样式
  for (let rowNumber = 2; rowNumber <= data.length + 1; rowNumber++) {
    const dataRow = worksheet.getRow(rowNumber);
    dataRow.height = 22; // 设置数据行高

    columns.forEach((col, colIndex) => {
      const cell = dataRow.getCell(colIndex + 1);

      // 设置单元格对齐方式
      cell.alignment = {
        vertical: "middle",
        horizontal: "left", // 默认左对齐
        wrapText: false, // 默认不换行
      };

      // 根据数据类型设置不同的对齐方式
      const value = cell.value;
      if (typeof value === "number") {
        // 数字右对齐
        cell.alignment.horizontal = "right";
      } else if (typeof value === "boolean") {
        // 布尔值居中对齐
        cell.alignment.horizontal = "center";
      }

      // 特定列的自定义对齐方式和换行设置
      switch (col.dataIndex) {
        case "rebateAmount": // 金额列右对齐
        case "amount":
          cell.alignment.horizontal = "right";
          break;
        case "rebateFormType": // 返利形式居中对齐
        case "productLineType": // 产品线居中对齐
        case "useScopeType": // 使用范围居中对齐
        case "ctime": // 时间居中对齐
        case "recordType": // 类型居中对齐
        case "creatorName": // 创建人居中对齐
          cell.alignment.horizontal = "center";
          break;
        case "policy": // 政策允许换行
        case "remark": // 备注允许换行
          cell.alignment.wrapText = true;
          break;
        default:
          break;
      }

      // 设置边框
      cell.border = {
        top: { style: "thin" },
        left: { style: "thin" },
        bottom: { style: "thin" },
        right: { style: "thin" },
      };
    });
  }

  // 为标题行也添加边框
  columns.forEach((_, colIndex) => {
    const cell = headerRow.getCell(colIndex + 1);
    cell.border = {
      top: { style: "thin" },
      left: { style: "thin" },
      bottom: { style: "thin" },
      right: { style: "thin" },
    };
  });

  // 自动调整列宽，并设置最小和最大宽度
  worksheet.columns.forEach((column, index) => {
    let maxLength = 0;
    column.eachCell({ includeEmpty: true }, (cell) => {
      const columnLength = cell.value ? cell.value.toString().length : 10;
      if (columnLength > maxLength) {
        maxLength = columnLength;
      }
    });

    // 为特定列设置最小宽度
    let minWidth = 10;
    const colName = columns[index].dataIndex;
    switch (colName) {
      case "productLineType": // 产品线
        minWidth = 15;
        break;
      case "useScopeType": // 使用范围
        minWidth = 15;
        break;
      case "agentName": // 代理商名称
        minWidth = 20;
        break;
      case "validityPeriod": // 有效期
        minWidth = 25;
        break;
      case "policy": // 政策
      case "remark": // 备注
        minWidth = 30;
        break;
      default:
        minWidth = 10;
    }

    // 设置列宽，但限制最大宽度为50
    column.width = Math.max(minWidth, Math.min(maxLength + 2, 50));
  });

  // 生成文件并下载
  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = `${fileName}.xlsx`;
  link.click();
  window.URL.revokeObjectURL(url);
}
